// Cross-route bridge: generator queues clip imports, StudioPage drains them
// on mount. Persisted to sessionStorage so a full reload during navigation
// (e.g. PWA cold start) doesn't drop the request.
import type { SceneSnapshot } from '../studio/types';

const KEY = 'protocut:pendingImports';

export type StudioImportRequest = {
  url?: string;                        // optional for 3d-scene
  name?: string;
  type?: 'video' | 'audio' | 'image' | 'text' | 'transition' | '3d-scene';
  trackId?: string;
  newTrack?: boolean;
  duration?: number;
  /** For type === '3d-scene' — frozen snapshot of the chat world. */
  sceneData?: SceneSnapshot;
};

export function queueStudioImport(req: StudioImportRequest) {
  try {
    const raw = sessionStorage.getItem(KEY);
    const list: StudioImportRequest[] = raw ? JSON.parse(raw) : [];
    list.push(req);
    sessionStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // sessionStorage unavailable — fall back to a transient window queue.
    (window as any).__protocutPending ??= [];
    (window as any).__protocutPending.push(req);
  }
}

export function drainStudioImports(): StudioImportRequest[] {
  let list: StudioImportRequest[] = [];
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) list = JSON.parse(raw);
    sessionStorage.removeItem(KEY);
  } catch {}
  const win = (window as any).__protocutPending as StudioImportRequest[] | undefined;
  if (win?.length) {
    list = list.concat(win);
    (window as any).__protocutPending = [];
  }
  return list;
}